import moment from 'moment-timezone';

export const getDateString = (date, formatFrom) => {
  return formatFrom
    ? moment?.utc(date)?.format('DD MMM YYYY')
    : moment(date)?.utc()?.format('lll');
};

export const formatDate = (date) => {
  if (isNaN(Number(date))) {
    return date;
  }

  let formattedDate = date.toString();
  formattedDate =
    formattedDate?.slice(0, 4) +
    '-' +
    formattedDate?.slice(4, 6) +
    '-' +
    formattedDate?.slice(6, 8);
  return formattedDate;
};

export const formatDaysTag = (day, valueReturn) => {
  if (Number(day) > 1) {
    return !valueReturn ? day + ' days' : ' days';
  } else {
    return !valueReturn ? day + ' day' : ' day';
  }
};
